import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';
import get from 'lodash/get';

import { actions as countryDetailsActions } from '../redux/data/countryDetails';
import { selectCountryDetails } from '../redux/data/selectors';

function normalizeStateList(list = []) {
  return list.map(({ name: label, code: value }) => ({
    label,
    value,
  }));
}

function getFullExamplesError(list = [], separator = ', ') {
  return list ? list.join(separator) : '';
}

export function useCountrySelect(formatMessage) {
  const dispatch = useDispatch();

  const countryDetails = useSelector(selectCountryDetails);

  const separator = formatMessage({ id: 'errors.validation.separator' });

  const { stateList, zipLimit, isZipApplicable, zipExamples } = useMemo(
    () => ({
      stateList: normalizeStateList(countryDetails.states),
      zipLimit: get(countryDetails, 'zipCode.length'),
      isZipApplicable: get(countryDetails, 'zipCode.applicable'),
      zipExamples: getFullExamplesError(
        get(countryDetails, 'zipCode.examples', ''),
        separator,
      ),
    }),
    [countryDetails],
  );

  const loadCountryDetails = code => {
    dispatch(countryDetailsActions.send({ code }));
  };

  return {
    loadCountryDetails,
    stateList,
    zipLimit,
    isZipApplicable,
    zipExamples,
  };
}



// WEBPACK FOOTER //
// ./src/hocs/useCountrySelect.js